const CJA_EVENTS = {
  CUSTOM_EVENT: 'customAnalyticsEvent',
  PAGE_LOAD: 'pageLoad',
  REGULAR_PAGE_LOAD: 'regularPageLoad',
  LINK_CLICK: 'linkClick',
  FILTER_APPLIED: 'filterApplied',
  OVERLAY_LOAD: 'overlayLoad',
  OVERLAY_CLOSE: 'overlayClose',
  SEARCH_INITIATE: 'searchInitiate',
  DROPSHIPHUB_SUBMISSION_SUCCESS: 'dropship_submission_success',
  OVERLOAD: 'overload'
};

const CJA_EVENT_INFO = {
  WTF_SEARCH_RESULT_PAGE: 'wtfSearchResultPage',
  SEARCH_RESULT_PAGE: 'Dropship Hub Project Search',
  USER_SEARCH: 'User Search - User Management'
}

const USER_ROLES = {
  internal: 'internal',
}

const LINK_TYPES = {
  BUTTON: 'button',
  BUTTON_CLICK: 'button_click',
  TOGGLE_INTERACTION: 'toggle_interaction',
  SYSTEM: 'system',
  ICON_CLICK: 'icon_click',
  LINK_TEXT: 'link_text',
  TEXT_LINK: 'text_link',
  ICON: 'icon',
  FIELD_CLICK: 'field_click',
  ICON_BUTTON: 'icon_button',
  FIELD: 'field',
};

const FILTER_TYPES = {
  STATUS: 'status',
  SELECT_DATE: 'Select Date',
  ALL_FOUNDRIES: 'All Foundries',
  ALL_SOURCES: 'All Sources',
  MORE_FILTERS: 'More Filters',
  FOUNDRY_NAMES: 'Foundry Names',
  QUARTERLY_FOUNDRY_NAME: 'Foundry Name',
  QUARTERLY_YEAR: 'Year'
};

const FILTER_VALUE = {
  RESET: 'reset'
};

const LINK_CATEGORIES = {
  SUB_HEADER: 'Sub Header',
  MAIN_HEADER: 'Main Header',
  DRAFTS: 'Drafts',
  PROJECTS: 'Projects',
  PROJECT_OVERLAY: 'Project Overlay',
  FLIP_FONT: 'FlipFont',
  PROJECT_NAME: 'Project name',
  NEW_PROJECT: 'New Project',
  AI_ASSISTANT: 'aiAssistant',
  INVENTORY_INGESTION_HUB: 'Inventory Hub',
  REPORT_DASHBOARD: 'report-dashboard',
  FOUNDRY_HEALTH: 'Foundry Health Suggestions',
  VIEW_DETAILS_FOUNDRY_HEALTH: 'view_details_foundry_health',
  CREATE_PROMOTION: 'create promotion',
  CREATE_BUNDLE: 'create bundle',
  VIEW_REPORT: 'View Report',
  VIDEO: 'video',
  ARTICLE: 'article',
  FOUNDRY_HELP_CENTER: 'foundry help center',
  PAYMENT_SCHEDULE: 'payment schedule',
  EMAIL_EXPERTS: 'email experts',
  READ_MORE: 'read more',
  LEARN_MORE: 'learn more',
  SIGN_AGREEMENT: 'sign agreement',
  VIEW_AGREEMENT: 'view agreement',
  NEW_FEATURES: 'new features',
  FINAL_SIGN_AGREEMENT: 'final agreement sign',
  DOWNLOAD_AGREEMENT: 'download agreement',
  SIGN_LATEST_AGREEMENT: 'sign the latest agreement dashboard',
  PAYMENTS_STATUS: 'Payments status',
  NAVIGATION: 'navigation',
  USER_PROFILE: 'navigation:user profile',
  EDIT_PROFILE: 'Edit Profile',
  MTF_LINK: 'MTF link',
  FONT_FAMILY_TAGS: 'Font Family Tags',
  APPLICATION_ALREADY_IN_PROGRESS: 'Application Already in Progress',
  EMAIL_SENT_DIALOG_BOX: 'Email Sent Dialog Box',
  EMAIL_VERIFICATION_BANNER: 'Email Verification Banner',
  EMAIL_VERIFICATION_BANNER_PAYMENT_SETUP: 'Email Verification Banner: Payment Setup',
  EMAIL_SENT_DIALOG_BOX_PAYMENT_SETUP: 'Email Sent Dialog Box: Payment Setup',
  FONT_FAMILY_TAGS: 'Font Family Tags',
  AGREEMENTS: 'Agreements',
  FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON: 'Foundry Partner Agreement Ending Soon',
  SIDE_PANEL_SIGN_LATEST_AGREEMENT: 'Side Panel: Sign Latest Agreement',
  FOUNDRY_INFORMATION: 'Foundry Information',
  MONOTYPE_FONT_DISTRIBUTION_AGREEMENT: 'Monotype Font Distribution Agreement',
};

const LINK_NAMES = {
  ADD: 'Add',
  RELATED_FAMILIES: 'related families',
  START_TYPING_THE_FAMILY_NAME_ACCORDION_CLICK: 'Start typing the family name - accordion click',
  PROCEED: 'Proceed New Project',
  DOWNLOAD_CSV: 'Download CSV',
  DOWNLOAD_REPORT: 'Download Report',
  VIEW_CONTRACTS: 'View Contracts',
  UPLOAD_FONT_FLIP: 'Upload FontFlip',
  DOWNLOAD_TEMPLATE_FILE: 'Download Template File',
  EDIT_DRAFT: 'Edit Draft',
  DELETE_ACTION: 'Delete Action - Dropship Draft Project',
  DELETE_CONFIRMED: 'Delete Confirmed',
  DELETE_FONT_FLIP: 'Delete FontFlip',
  DELETE_CONFIRMATION_FONT_FLIP: 'Delete Confirmation FontFlip',
  SELECT_CONTRACT_NUMBER: 'Select Contract Number',
  NEW_PROJECT: 'New Project',
  MAP_FAMILY: 'Map Family Confirmed',
  EARNINGS: 'Earnings',
  ORDERS: 'Orders',
  VIEW_DETAILS_FOUNDRY_HEALTH: 'View Details',
  CREATE_PROMOTION: 'Create a Promotion',
  CREATE_BUNDLE: 'Create a Bundle',
  VIEW_REPORT: 'View Report',
  LEARN_MORE: 'Learn More',
  WATCH_NOW: 'Watch Now',
  READ_NOW: 'Read Now',
  EDIT_PAYMENT_ACCOUNTS: 'Edit Payment Accounts',
  SIGN_LATEST_AGREEMENT: 'sign the latest agreement',
  SIGN_AGREEMENT: 'sign agreement',
  START_SIGN_AGREEMENT: 'start signing agreement',
  DOWNLOAD_AGREEMENT: 'download agreement',
  VIEW_AGREEMENT: 'view current agreement',
  BEGIN: 'begin',
  EMAIL_EXPERTS: 'email experts',
  EDIT_PROFILE: 'Edit Profile',
  DEFAULT_FOUNDRY: 'Default Foundry -',
  DISCARD: 'Discard -',
  SAVE_CHANGES: 'Save Changes -',
  DELETE_USER: 'Delete User',
  SPLIT_FAMILY: 'Split Family',
  REMOVE_STYLE_NAME: 'Remove Style Name',
  CREATE_NEW_FAMILY: 'Create New Family',
  ERROR_FAMILY_NAME_ALREADY_USED: 'Error: This family name is already used in this project',
  ERROR_FAMILY_NAME_INVALID_CHARACTERS: 'Error: Name can’t contain special characters like /, @, #, or %',
  REFINE_DISPLAY_STYLE_NAME: 'Refine display style name',
  SAVE_REPLACEMENTS: 'Save replacements',
  REVIEW_BUTTON_CLICK: 'Review button click',
  BACK_BUTTON_CLICK_RESULT_SUCCESS: 'Back Navigation - result success',
  BACK_BUTTON_CLICK_RESULT_NO_RESULTS: 'Back Navigation - no results',
  DISPLAY_NAME_SHOULD_BE_WITHIN_CHARACTER_LIMIT: 'Display name should be within character limit',
  COULD_NOT_FIND_A_MATCH: "Could not find a match",
  CURRENT_AND_IMPACTED_STYLES_LOADED: "Current and Impacted Styles Loaded",
  CREATE_NEW_FAMILY_NAME: 'Create New Family Name',
  CLEAR_ALL_TAGS: 'Clear All Tags',
  SUBMIT_FEEDBACK: 'Submit Feedback',
  CROSS_FEEDBACK: 'Cross: Feedback',
  NEW_USER_TAG_GENERATED: 'New User Tag Generated',
  CHECK_OUR_GUIDE: 'Check Our Guide',
  CLICK_HERE_WHY_20_TAGS: 'Click Here: Why 20 tags are best',
  ADD_SUGGESTED_TAGS: 'Add Suggested Tags',
  SUBMIT_NEXT: 'Submit/Next',
  GET_STARTED: 'Get Started',
  SEND_EMAIL: 'Send Email',
  RESEND_EMAIL: 'Resend Email',
  CLOSE: 'Close',
  VERIFY: 'Verify',
  VERIFY_WITH_EMAIL_DISMISSED_BANNER: 'Verify with Email: Dismissed Banner',
  VERIFY_WITH_EMAIL_PAYMENT_SETUP: 'Verify with Email: Payment Setup',
  RESEND_EMAIL_PAYMENT_SETUP: 'Resend Email: Payment Setup',
  CLOSE: 'Close',
  SEE_WHATS_CHANGED: "See What's Changed",
  CONTACT_FOUNDRY_SUPPORT: 'Contact Foundry Support',
  LEARN_MORE_CONTRACT_TERMINATION: 'Learn More :Contract Termination Process',
  LEARN_MORE_REJOINING_FOUNDRY: 'Learn More : Re-Joining Foundry',
};

const SEARCH_SECTION = {
  EARNING_REPORT: 'earning report search',
  USER_SEARCH: 'User Management'
}

const LINK_SECTION = {
  FAMILY_OVERVIEW: 'Family Overview',
  DASHBOARD: 'dashboard',
  BUNDLE_DASHBOARD: 'dashboard-bundle',
  PROMOTION_DASHBOARD: 'dashboard-promotion',
  PAYMENTS: 'payments',
  AGREEMENTS: 'agreements',
  SIGN_AGREEMENTS: 'sign agreement',
  EARNINGS_REPORT: 'Earning Report',
  DROPSHIP_HUB: 'Dropship Hub',
  RELATED_FAMILIES: 'Related Families',
  IH_FAMILY_EDIT: 'IH_family_edit',
  FOUNDRY_INFO: 'Foundry Information',
  BOTTOM_ACTION_BAR: 'Bottom Action Bar',
  POP_UP_SCREEN: 'Pop Up Screen',
  CREATE_NEW_FAMILY_FROM_STYLES_OVERLAY: 'Create New Family from styles Overlay',
  REVIEW_REPLACEMENTS_FOR_FAMILIES_MODAL: 'Review replacements for families Modal',
  SUBMISSIONS: 'Submissions',
  INVENTORY_HUB: 'Inventory Hub',
  FOUNDRY_PARTNER_AGREEMENT_ENDING_SOON: 'Foundry Partner Agreement Ending Soon',
  SIDE_PANEL: 'Side Panel',
  QUARTERLY_ROYALTY_REPORTS: 'manage earnings : quarterly reports',
};

const OVERLAY = {
  OVERLAY_LOAD: 'overlayLoad',
  OVERLAY_CLOSE: 'overlayClose'
}

const COMMON = {
  LOGGED_USER: 'logged in',
  GUEST: 'guest',
  PAGE_LOAD_EVENT_DELAY: 2000,
  SUGGESTION_DISCARDED: 'suggestionOutcome_discarded',
  SUGGESTION_ACCEPTED: 'suggestionOutcome_accepted'
};

/**
 * AI Action transformation map
 * Maps original action names to their AI-specific equivalents for analytics
 *
 * Usage: AI_ACTION_MAP[originalAction] || originalAction
 */
const AI_ACTION_MAP = {
  // Actions that need transformation for AI analytics
  polishWriting: 'refineWriting',

  // Actions that stay the same (can be omitted, but kept for clarity)
  boostVisibility: 'boostVisibility',
  fixGrammar: 'fixGrammar',
  shortenText: 'shortenText'
};


const ERROR_MAP = {
  404: {
    errorCode: '404',
    errorMessage: 'Page not found',
    errorType: 'Not Found'
  },
  403: {
    errorCode: '403',
    errorMessage: 'Forbidden',
    errorType: 'Forbidden'
  },
  500: {
    errorCode: '500',
    errorMessage: 'Internal Server Error',
    errorType: 'Server Error'
  },
  503: {
    errorCode: '503',
    errorMessage: 'Service Unavailable',
    errorType: 'Service Unavailable'
  },
  400: {
    errorCode: '400',
    errorMessage: 'Bad Request',
    errorType: 'Client Error'
  },
  412: {
    errorCode: '412',
    errorMessage: 'Precondition Failed',
    errorType: 'Client Error'
  },
  424: {
    errorCode: '424',
    errorMessage: 'Failed Dependency',
    errorType: 'Client Error'
  }
};

export {
  CJA_EVENTS,
  COMMON,
  LINK_TYPES,
  LINK_SECTION,
  LINK_CATEGORIES,
  ERROR_MAP,
  LINK_NAMES,
  CJA_EVENT_INFO,
  FILTER_TYPES,
  OVERLAY,
  SEARCH_SECTION,
  FILTER_VALUE,
  AI_ACTION_MAP,
  USER_ROLES
};
